import { Form } from '@remix-run/react';
import { z } from 'zod';
import { Icon } from '#app/components/ui/icon.tsx';
import { StatusButton } from '#app/components/ui/status-button.tsx';
import { useIsPending } from './misc.tsx';

// * To add another provider, set their name here and add it to the providerNames below
export const GOOGLE_PROVIDER_NAME = 'google';
export const providerNames = [GOOGLE_PROVIDER_NAME] as const;
export const ProviderNameSchema = z.enum(providerNames);
export type ProviderName = z.infer<typeof ProviderNameSchema>;

export const providerLabels: Record<ProviderName, string> = {
  [GOOGLE_PROVIDER_NAME]: 'Google',
} as const;

export const providerIcons: Record<ProviderName, React.ReactNode> = {
  [GOOGLE_PROVIDER_NAME]: <Icon name="google" />,
} as const;

export function ProviderConnectionForm({
  redirectTo,
  type,
  providerName,
}: {
  redirectTo?: string | null;
  type: 'Connect' | 'Login' | 'Signup' | 'Activate';
  providerName: ProviderName;
}) {
  const label = providerLabels[providerName];
  const formAction = `/auth/${providerName}`;
  const isPending = useIsPending({ formAction });
  return (
    <Form className="w-full" action={formAction} method="POST">
      {redirectTo ? <input type="hidden" name="redirectTo" value={redirectTo} /> : null}
      <input type="hidden" name="ssoType" value={type} />
      <StatusButton type="submit" className="w-full" status={isPending ? 'pending' : 'idle'} usedWithFields={false}>
        <span className="inline-flex items-center gap-1.5">
          {providerIcons[providerName]}
          <span>
            {type} with {label}
          </span>
        </span>
      </StatusButton>
    </Form>
  );
}
